/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorPaginationDto } from '../../models/cursor-pagination-dto';

export interface TicketControllerSearchCursor$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 아동 ID
 */
  childId?: string;

/**
 * 사용자 ID
 */
  userId?: string;

/**
 * 타입
 */
  type?: string;

/**
 * 센터 User ID
 */
  centerId?: string;

/**
 * 담당 선생님
 */
  teacherIds?: Array<string>;

/**
 * 바우처
 */
  vouchers?: Array<string>;

/**
 * 치료 상태
 */
  statusList?: Array<'BEFORE_COUNSELING' | 'PENDING' | 'PROGRESS' | 'COMPLETED'>;

/**
 * 상태
 */
  status?: '\uCD08\uAE30\uC0C1\uB2F4 \uC804' | '\uB300\uAE30' | '\uC9C4\uD589' | '\uC885\uACB0' | 'ALL';
}

export function ticketControllerSearchCursor(http: HttpClient, rootUrl: string, params: TicketControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerSearchCursor.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('childId', params.childId, {});
    rb.query('userId', params.userId, {});
    rb.query('type', params.type, {});
    rb.query('centerId', params.centerId, {});
    rb.query('teacherIds', params.teacherIds, {});
    rb.query('vouchers', params.vouchers, {});
    rb.query('statusList', params.statusList, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorPaginationDto>;
    })
  );
}

ticketControllerSearchCursor.PATH = '/api/ticket/search/cursor';
